export const pythonObject = `query pythonObject($id: ID!) {
  pythonObject(id: $id){
    objectName
    objectSubtitle
    objectIntroduction
    videoUrl
    videoBackground{
      url
    }
    topImg{
      url
    }
    videoDesc
    botImg{
      url
    }
    isPublish
    about
    logo{
      url
    }
    router
    bannerColor
    bannerImg{
      url
    }
    funDemonstration
    technicalFile
    modular{
      id
      title
      subTitle
      bgColor
      bgImg{
        url
      }
      file{
        url
      }
      url
    }
    ClassTitle
    ClassEnTitle
    ClassList{
      id
      title
      subTitle
      desc
    }
    TeachModleTitle
    TeachEnTitle
    TeachBgColor
    TeachBgImg{
      url
    }
    Teacheres{
      id
      name
      quarters
      realName
      headerImage {
        url
      }
      details
      isPublic
      sortNum
    }
    advantageModleTitle
    advantageModleSubTitle
    advantageEnTitle
    advantageList{
      iconImg{
        url
      }
      title
      desc
    }
    sceneModleTitle
    sceneModleEnTitle
    sceneModleSubtitle
    sceneBgColor
    sceneBgImg{
      url
    }
    sceneList{
      image{
        url
      }
      title
      desc
    }
    funIntroductionTitle
    funIntroductionSubTitle
    funIntroductionEnTitle
    funIntroductionList{
      iconImg{
        url
      }
      title
      desc
    }
  }
}`
